import { reasonOptions } from "./consts";

export const buildCreditTableObservation = (
  reason: string,
  observations?: string
): string => {
  const reasonLabel =
    reasonOptions.find((option) => option.value === reason)?.label || reason;
  const trimmedObservations = observations?.trim();

  return trimmedObservations
    ? `${reasonLabel} ${trimmedObservations}`
    : reasonLabel;
};
